import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Layout from "../components/Layout";
import SEOHead from "../components/SEOHead";
import PageHeader from "../components/PageHeader";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { auth } from "../lib/api";
import { fetchDemoCredentials } from "../lib/demoCredentials";
import { toast } from "sonner";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [legacy, setLegacy] = useState({ email: "", password: "" });
  const nav = useNavigate();

  useEffect(() => {
    fetchDemoCredentials().then(d => setLegacy(d?.legacy_admin || { email: "", password: "" }));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await auth.login(email, password);
      auth.saveToken(r.access_token);
      toast.success(`Welcome, ${r.user.name}`);
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    }
    setBusy(false);
  };

  return (
    <Layout>
      <SEOHead title="Admin Login | AuditIQ" path="/admin/login" />
      <PageHeader eyebrow="Admin" title="Secure access" subtitle="JWT-protected admin dashboard for leads, audit logs, and brand assets." />
      <section className="max-w-[520px] mx-auto px-6 py-14">
        <form onSubmit={submit} className="panel-elev p-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="text-[11px] uppercase tracking-[0.22em] text-steel">Email</label>
            <Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1 bg-navy-deep border-gold-dim/40" data-testid="admin-email" />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-[0.22em] text-steel">Password</label>
            <Input required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1 bg-navy-deep border-gold-dim/40" data-testid="admin-password" />
          </div>
          <Button disabled={busy} className="btn-gold h-11 w-full" data-testid="admin-login-btn">
            {busy ? "Signing in…" : "Sign In"}
          </Button>
          <div className="text-xs text-steel text-center">
            Default demo admin: <span className="text-gold">{legacy.email || "—"}</span> · <span className="text-gold">{legacy.password || "—"}</span>
          </div>
          <div className="text-xs text-steel text-center"><Link to="/" className="hover:text-gold">← Back to site</Link></div>
        </form>
      </section>
    </Layout>
  );
};

export default AdminLogin;
